"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripleSelectorChips = exports.DoubleSelectorChips = exports.SelectorChips = void 0;
const react_1 = __importDefault(require("react"));
const Styles = __importStar(require("./selector-chips.style"));
function withSelectableOptions(WrappedComponent) {
    return function SelectableOptionsComponent(props) {
        const { options, onClick, isMultipleSelect = false } = props;
        const handleOptionClick = (option) => {
            const updatedOptions = options.map((selectedOption) => selectedOption.id === option.id
                ? Object.assign(Object.assign({}, selectedOption), { isSelected: !selectedOption.isSelected }) : isMultipleSelect
                ? selectedOption
                : Object.assign(Object.assign({}, selectedOption), { isSelected: false }));
            onClick(option, updatedOptions);
        };
        return (react_1.default.createElement(WrappedComponent, Object.assign({}, props, { options: options, onClick: handleOptionClick })));
    };
}
exports.SelectorChips = withSelectableOptions(function SelectorChipsInternal(props) {
    const { className, options, children, width, height, margin, onClick } = props;
    return (react_1.default.createElement(Styles.Wrapper, { className: className }, options === null || options === void 0 ? void 0 :
        options.map((option) => (react_1.default.createElement(Styles.Option, { key: option.id, isSelected: option.isSelected, width: width, height: height, margin: margin, onClick: () => onClick(option, []) },
            react_1.default.createElement(Styles.Text, null, option.value)))),
        children));
});
exports.DoubleSelectorChips = withSelectableOptions(function DoubleSelectorChipsInternal(props) {
    const { className, options, children, width, height, margin, onClick } = props;
    return (react_1.default.createElement(Styles.DoubleWrapper, { className: className }, options === null || options === void 0 ? void 0 :
        options.map((option) => (react_1.default.createElement(Styles.DoubleOption, { key: option.id, isSelected: option.isSelected, width: width, height: height, margin: margin, onClick: () => onClick(option, []) },
            react_1.default.createElement(Styles.Text, null, option.value)))),
        children));
});
exports.TripleSelectorChips = withSelectableOptions(function TripleSelectorChipsInternal(props) {
    const { className, options, children, width, height, margin, onClick } = props;
    return (react_1.default.createElement(Styles.TripleWrapper, { className: className }, options === null || options === void 0 ? void 0 :
        options.map((option) => (react_1.default.createElement(Styles.TripleOption, { key: option.id, isSelected: option.isSelected, width: width, height: height, margin: margin, onClick: () => onClick(option, []) },
            react_1.default.createElement(Styles.Text, null, option.value)))),
        children));
});
//# sourceMappingURL=selector-chips.js.map